import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from "../config/config";

const EditStudyAbroad = () => {
  const { id } = useParams(); // Assuming route is like /admin/edit-study-abroad/:id
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    bannnerHeading: "",
    bannnerSubHeading1: "",
    bannnerSubHeading2: "",
    tableHeading: "",
    tableSubHeading: "",
    tablelist: [],
    cardlist: [],
  });

  const [tableImages, setTableImages] = useState({});
  const [cardImages, setCardImages] = useState({});

  useEffect(() => {
    // Fetch existing data
    axios.get(`${config.API_BASE_URL}/api/admin/get_studyaboradbyId/${id}`)
      .then((res) => {
        setFormData(res.data.getAllStudyAboradById);
      })
      .catch((err) => {
        console.error("Error fetching study abroad data:", err);
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTableChange = (index, field, value) => {
    const updatedList = [...formData.tablelist];
    updatedList[index][field] = value;
    setFormData(prev => ({ ...prev, tablelist: updatedList }));
  };

  const handleCardChange = (index, field, value) => {
    const updatedList = [...formData.cardlist];
    updatedList[index][field] = value;
    setFormData(prev => ({ ...prev, cardlist: updatedList }));
  };

  const handleTableImageChange = (index, file) => {
    setTableImages(prev => ({ ...prev, [index]: file }));
  };

  const handleCardImageChange = (index, file) => {
    setCardImages(prev => ({ ...prev, [index]: file }));
  };

  const addTableRow = () => {
    setFormData(prev => ({
      ...prev,
      tablelist: [...prev.tablelist, { collageName: "", fees: "", dicountFee: "", image: "" }]
    }));
  };

  const removeTableRow = (index) => {
    const updatedList = [...formData.tablelist];
    updatedList.splice(index, 1);
    setFormData(prev => ({ ...prev, tablelist: updatedList }));
  };

  const addCardRow = () => {
    setFormData(prev => ({
      ...prev,
      cardlist: [...prev.cardlist, { text: "", image: "" }]
    }));
  };

  const removeCardRow = (index) => {
    const updatedList = [...formData.cardlist];
    updatedList.splice(index, 1);
    setFormData(prev => ({ ...prev, cardlist: updatedList }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = new FormData();

      submitData.append("bannnerHeading", formData.bannnerHeading);
      submitData.append("bannnerSubHeading1", formData.bannnerSubHeading1);
      submitData.append("bannnerSubHeading2", formData.bannnerSubHeading2);
      submitData.append("tableHeading", formData.tableHeading);
      submitData.append("tableSubHeading", formData.tableSubHeading);

      submitData.append("tablelist", JSON.stringify(formData.tablelist));
      submitData.append("cardlist", JSON.stringify(formData.cardlist));

      // Attach new table images if changed
      Object.keys(tableImages).forEach(index => {
        submitData.append(`tablelist[${index}][image]`, tableImages[index]);
      });

      // Attach new card images if changed
      Object.keys(cardImages).forEach(index => {
        submitData.append(`cardlist[${index}][image]`, cardImages[index]);
      });

      await axios.put(`${config.API_BASE_URL}/api/admin/update_studyaboradbyId/${id}`, submitData);

      alert("Study Abroad Page updated successfully!");
      navigate("/admin/studyabroad"); // Redirect back to list page
    } catch (error) {
      console.error("Error updating study abroad page:", error);
      alert("Failed to update Study Abroad Page.");
    }
  };

  return (
    <div className="container mt-5 pt-5">
    <div className="row">
     <div className="col-lg-2"></div>
     <div className="col-lg-10">
       <h2>Edit Study Abroad Page</h2>

      <form onSubmit={handleSubmit} encType="multipart/form-data">

        {/* Basic Inputs */}
        <div className="mb-3">
          <label>Banner Heading</label>
          <input type="text" className="form-control" name="bannnerHeading" value={formData.bannnerHeading} onChange={handleChange} />
        </div>

        <div className="mb-3">
          <label>Banner Sub Heading 1</label>
          <input type="text" className="form-control" name="bannnerSubHeading1" value={formData.bannnerSubHeading1} onChange={handleChange} />
        </div>

        <div className="mb-3">
          <label>Banner Sub Heading 2</label>
          <input type="text" className="form-control" name="bannnerSubHeading2" value={formData.bannnerSubHeading2} onChange={handleChange} />
        </div>

        <div className="mb-3">
          <label>Table Heading</label>
          <input type="text" className="form-control" name="tableHeading" value={formData.tableHeading} onChange={handleChange} />
        </div>

        <div className="mb-3">
          <label>Table Sub Heading</label>
          <input type="text" className="form-control" name="tableSubHeading" value={formData.tableSubHeading} onChange={handleChange} />
        </div>

        {/* Table List */}
        <h4>Table List</h4>
        {formData.tablelist.map((item, index) => (
          <div key={index} className="border p-3 mb-3">
            <input type="text" className="form-control mb-2" placeholder="College Name" value={item.collageName} onChange={(e) => handleTableChange(index, 'collageName', e.target.value)} />
            <input type="text" className="form-control mb-2" placeholder="Fees" value={item.fees} onChange={(e) => handleTableChange(index, 'fees', e.target.value)} />
            <input type="text" className="form-control mb-2" placeholder="Discount Fee" value={item.dicountFee} onChange={(e) => handleTableChange(index, 'dicountFee', e.target.value)} />

            <label>Upload New Image</label>
            <input type="file" className="form-control mb-2" onChange={(e) => handleTableImageChange(index, e.target.files[0])} />

            <button type="button" className="btn btn-danger" onClick={() => removeTableRow(index)}>Remove</button>
          </div>
        ))}
        <button type="button" className="btn btn-primary mb-3" onClick={addTableRow}>Add More Table Row</button>

        {/* Card List */}
        <h4>Card List</h4>
        {formData.cardlist.map((item, index) => (
          <div key={index} className="border p-3 mb-3">
            <input type="text" className="form-control mb-2" placeholder="Text" value={item.text} onChange={(e) => handleCardChange(index, 'text', e.target.value)} />

            <label>Upload New Image</label>
            <input type="file" className="form-control mb-2" onChange={(e) => handleCardImageChange(index, e.target.files[0])} />

            <button type="button" className="btn btn-danger" onClick={() => removeCardRow(index)}>Remove</button>
          </div>
        ))}
        <button type="button" className="btn btn-primary mb-3" onClick={addCardRow}>Add More Card Row</button>

        {/* Submit */}
        <button type="submit" className="btn btn-success">Update Study Abroad Page</button>
      </form>
     </div>
    </div>
    </div>
  );
};

export default EditStudyAbroad;
